<template>
  <div class="testimonial-section">
    <div class="container">
      <!-- Header -->
      <div class="header">
        <h2 class="title">People Love What We Do</h2>
        <p class="subtitle">
        </p>
      </div>

      <div class="outer_wrapper">
        <button
          class="nav-arrow nav-arrow-left"
          @click="previousTestimonial"
          aria-label="Previous testimonial"
        >
          <svg
            width="59"
            height="59"
            viewBox="0 0 59 59"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <circle
              cx="29.5"
              cy="29.5"
              r="29.5"
              transform="rotate(-180 29.5 29.5)"
              fill="white"
            />
            <path
              d="M18.2929 27.2929C17.9024 27.6834 17.9024 28.3166 18.2929 28.7071L24.6569 35.0711C25.0474 35.4616 25.6805 35.4616 26.0711 35.0711C26.4616 34.6805 26.4616 34.0474 26.0711 33.6569L20.4142 28L26.0711 22.3431C26.4616 21.9526 26.4616 21.3195 26.0711 20.9289C25.6805 20.5384 25.0474 20.5384 24.6569 20.9289L18.2929 27.2929ZM40 28L40 27L19 27L19 28L19 29L40 29L40 28Z"
              fill="#14163C"
            />
          </svg>
        </button>

        <button
          class="nav-arrow nav-arrow-right"
          @click="nextTestimonial"
          aria-label="Next testimonial"
        >
          <svg
            width="59"
            height="59"
            viewBox="0 0 59 59"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <circle cx="29.5" cy="29.5" r="29.5" fill="white" />
            <path
              d="M40.7071 31.7071C41.0976 31.3166 41.0976 30.6834 40.7071 30.2929L34.3431 23.9289C33.9526 23.5384 33.3195 23.5384 32.9289 23.9289C32.5384 24.3195 32.5384 24.9526 32.9289 25.3431L38.5858 31L32.9289 36.6569C32.5384 37.0474 32.5384 37.6805 32.9289 38.0711C33.3195 38.4616 33.9526 38.4616 34.3431 38.0711L40.7071 31.7071ZM19 31V32H40V31V30H19V31Z"
              fill="#14163C"
            />
          </svg>
        </button>

        <!-- Testimonial Card -->
        <div class="testimonial-card">

          <!-- Name and Title -->
          <div class="profile-info">
            <p>{{ currentTestimonial.text }}</p>
          </div>
        </div>

        <!-- Star Rating -->
        <div class="star-rating">
          <svg
            v-for="n in 5"
            :key="n"
            class="star"
            width="38"
            height="38"
            viewBox="0 0 38 38"
            fill="currentColor"
          >
            <path
              d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
            />
          </svg>
        </div>

        <!-- Testimonial Text -->
        <div class="testimonial-text">
          <h3 class="name">{{ currentTestimonial.name }}</h3>
          <p class="role">{{ currentTestimonial.role }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import profile from "@/assets/Professional.png";
// Sample testimonial data
const testimonials = ref([
  {
    id: 1,
    name: "HR Director attended a team leadership event",
    // role: 'Founder of Joga4Life',
    image: "../",
    text: "It really helped refresh my mind from the day to day monotony. Ethnic Events really helped us have a fun and enriching experience.",
  },
  {
    id: 2,
    name: "University of Chicago Alumna who attended a team event",
    // role: 'CEO of TechFlow',
    image:
      "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face",
    text: "This was so fun, creative, and relaxing.",
  },
  {
    id: 3,
    name: "Chicago Cultural Organizer",
    // role: 'Product Manager at InnovateCorp',
    image:
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
    text: "I had such a pleasant experience having my first ever virtual soap making class with Ethnic Events! Nitha and Raven were very patient and always very professional. They handled most everything! All I had to do was get the product out the door and go virtual! I was lucky enough to have 2 classes hosted with them.",
  },
  {
    id: 4,
    name: "Chef/owner who hosted a Diwali event",
    image:
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
    text: "I was so happy to share our Indian culture and festival and also meet new customers. Ethnic Events made the process so easy and fun! We learned so much in the process and also have new customers!",
  },
]);

const currentIndex = ref(0);

const currentTestimonial = computed(
  () => testimonials.value[currentIndex.value],
);

const nextTestimonial = () => {
  currentIndex.value = (currentIndex.value + 1) % testimonials.value.length;
};

const previousTestimonial = () => {
  currentIndex.value =
    currentIndex.value === 0
      ? testimonials.value.length - 1
      : currentIndex.value - 1;
};
</script>

<style scoped>
.testimonial-section {
  background: #fff1e4;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 1rem 80px 1rem;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif;
}

.container {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
}

.header {
  text-align: center;
  margin-bottom: 4rem;
}

.title {
  font-size: 28.75px;
  font-weight: 700;
  color: #14163c;
  margin-bottom: 1rem;
  margin-top: 35px;
  letter-spacing: -0.025em;
}

.subtitle {
  font-size: 13.7px;
  font-weight: 500;
  color: #14163c;
  line-height: 1.6;
  max-width: 532.12px;
  margin: 0 auto;
}

.outer_wrapper {
  position: relative;
}

.testimonial-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 2rem;
  padding: 0 30px 30px 30px;
  box-shadow: 0 10px 20px -12px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 120px;
}

.testimonial-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 35px 60px -12px rgba(0, 0, 0, 0.15);
}

.nav-arrow {
  position: absolute;
  top: 18%;
  transform: translateY(-18%);
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #64748b;
  z-index: 10;
}

.nav-arrow-left {
  left: -1.5rem;
}

.nav-arrow-right {
  right: -1.5rem;
}

.profile-image {
  width: 130px;
  height: 130px;
  margin: 0 auto 24px;
  border-radius: 50%;
  overflow: hidden;
  border: 4px solid #fff;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  margin-top: -65px;
}

.profile-image:hover {
  transform: scale(1.05);
}

.profile-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.dotted-line {
  width: 200px;
  height: 2px;
  background-image: radial-gradient(circle, #cbd5e1 2px, transparent 2px);
  background-size: 10px 2px;
  background-repeat: repeat-x;
  margin: 0 auto 2rem;
  opacity: 0.6;
}

.name {
  font-size: 1rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 0.5rem;
}

.role {
  font-size: 14px;
  color: #64748b;
  margin: 0;
}

.star-rating {
  display: flex;
  justify-content: center;
  gap: 0.25rem;
  margin-bottom: 2rem;
  margin-top: 35px;
}

.star {
  color: #fbbf24;
  transition: transform 0.2s ease;
  transform: scale(1.4);
}

.star:hover {
  transform: scale(1.6);
}

.testimonial-text {
  max-width: 756px;
  margin: 0 auto;
  text-align: center;
}

.testimonial-text p {
  font-size: 14px;
  line-height: 1.7;
  color: #14163c;
  font-style: italic;
  margin: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
  .testimonial-section {
    padding: 1rem;
  }

  .title {
    font-size: 2rem;
  }

  .subtitle {
    font-size: 1rem;
  }

  .testimonial-card {
    padding: 2rem 1.5rem;
    margin: 0 1rem;
  }

  .nav-arrow {
    width: 2.5rem;
    height: 2.5rem;
  }

  .nav-arrow-left {
    left: -0.75rem;
  }

  .nav-arrow-right {
    right: -0.75rem;
  }

  .profile-image {
    width: 100px;
    height: 100px;
  }

  .testimonial-text p {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .nav-arrow {
    position: static;
    transform: none;
    margin: 1rem 0.5rem 0;
    display: inline-flex;
  }

  .nav-arrow-left,
  .nav-arrow-right {
    left: auto;
    right: auto;
  }

  .header {
    margin-bottom: 2rem;
  }

  .dotted-line {
    width: 150px;
  }
}
.profile-info {
  margin-top: 30px;
  line-height: 20px;
}
</style>
